import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Loader2, MessageCircle } from 'lucide-react';
import { ConsumerLayout } from '@/components/consumer/ConsumerLayout';
import { useConversasConsumer } from '@/hooks/useChatApp';

export default function ConsumerConversas() {
  const { t } = useTranslation();
  const { data, isLoading } = useConversasConsumer();

  return (
    <ConsumerLayout>
      <h1 className="text-xl font-bold mb-4">{t('chat.title')}</h1>
      {isLoading ? (
        <div className="flex justify-center py-16"><Loader2 className="h-6 w-6 animate-spin text-muted-foreground" /></div>
      ) : (data ?? []).length === 0 ? (
        <div className="flex flex-col items-center text-center gap-2 py-16 text-muted-foreground">
          <MessageCircle className="h-10 w-10" />
          <p className="text-sm max-w-xs">{t('chat.empty')}</p>
        </div>
      ) : (
        <ul className="flex flex-col gap-1">
          {(data ?? []).map((c) => (
            <li key={c.cliente_id}>
              <Link to={`/app/conversas/${c.cliente_id}`} className="ow-card p-3 flex items-center gap-3 hover:border-primary transition-colors">
                {c.empresa.logo_url
                  ? <img src={c.empresa.logo_url} alt="" className="h-10 w-10 rounded-lg object-cover" />
                  : <div className="h-10 w-10 rounded-lg bg-muted flex items-center justify-center font-bold">{(c.empresa.nome[0] ?? '?').toUpperCase()}</div>}
                <div className="min-w-0 flex-1">
                  <div className="font-medium truncate">{c.empresa.nome}</div>
                  <div className="text-xs text-muted-foreground truncate">{c.ultima_mensagem ?? ''}</div>
                </div>
                {c.nao_lidas > 0 && <span className="ml-auto text-xs bg-primary text-primary-foreground rounded-full px-2 py-0.5">{c.nao_lidas}</span>}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </ConsumerLayout>
  );
}
